<template>
	<div class="u-handle flex-grow flex-center">
		<div class="u-handle-main flex-grow flex-center" :style="{'color': currentName ? 'var(--color-main)' : ''}" @click="handle">
			<span>{{currentName || label}}</span>
			<div v-if="type == 'sort'" class="u-handle-sort flex-column flex-center">
				<i class="tf" :class="{'z-active': sortType == 'asc'}">&#xe733;</i>
				<i class="tf" :class="{'z-active': sortType == 'desc'}">&#xe736;</i>
			</div>
			<i v-else class="u-handle-arrow tf">&#xe6ff;</i>
		</div>

		<c-scroll v-if="type == 'option' && activeState" class="u-handle-option an an-slidein-top">
			<ul>
				<li v-for="(item, i) in optionList" :key="i" class="flex-between-center" :class="{'z-crt': currentOption == item.value}" @click="optionHandle(item)">
					<span>{{item.name}}</span>
				</li>
			</ul>
		</c-scroll>

		<div v-if="type == 'model' && activeState" class="u-handle-model flex-column an an-slidein-top">
			<c-scroll class="category" scroll-x>
				<ul class="flex-start-center">
					<li v-for="(item, i) in categoryList" :key="i" :class="{'z-crt': currentCategory == item.value}" @click="currentCategory = item.value">{{item.name}}</li>
				</ul>
			</c-scroll>
			<div class="flex-grow flex">
				<c-scroll v-show="brandList.length" class="brand">
					<ul>
						<li v-for="(item, i) in brandList" :key="i" :class="{'z-crt': currentBrand == item.value}" @click="currentBrand = item.value">{{item.name}}</li>
					</ul>
				</c-scroll>
				<c-scroll class="model flex-grow">
					<ul class="flex-wrap">
						<li v-for="(item, i) in modelList" :key="i" class="flex-center" :class="{'z-crt': currentModel && currentModel.value == item.value}" @click="modelHandle(item)">{{item.name}}</li>
					</ul>
					<c-empty v-if="!modelList.length"></c-empty>
				</c-scroll>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'topbarHandle',

		props: {
			type: String,
			label: String,
			name: String,
			options: [Array, String]
		},

		data() {
			return {
				optionList: [],
				currentOption: '',

				sortType: '',

				categoryList: [],
				currentCategory: '',
				brandList: [],
				currentBrand: '',
				modelList: [],
				currentModel: null,

				activeState: false
			}
		},

		computed: {
			currentName() {
				if (this.type == 'option' && this.currentOption) {
					return this.optionList.find(item => item.value == this.currentOption).name;
				} else if (this.type == 'model' && this.currentModel) {
					return this.currentModel.name;
				} else {
					return '';
				}
			},

			params() {
				if (this.type == 'option') {
					return {
						[this.name]: this.currentOption
					}
				} else if (this.type == 'sort') {
					return {
						sort_by: this.sortType ? this.name : '',
						sort_type: this.sortType
					}
				} else if (this.type == 'model') {
					return {
						[this.name]: this.currentModel ? this.currentModel.value : ''
					}
				}
			}
		},

		watch: {
			currentCategory(val) {
				val && this.updateBrand();
			},

			currentBrand(val) {
				val && this.updateModel();
			},

			params(val) {
				this.$emitBus('topbarHandle.update', val);
			}
		},

		mounted() {
			if (this.type == 'option') {
				if (Array.isArray(this.options)) {
					this.optionList = this.options;
				} else if (this.options == 'CHANNEL') {
					this.request({
						url: '/sale/product/channel/options',
						success: data => {
							this.optionList = data.map(item => {
								return {
									name: item.channel_name,
									value: item.channel_id
								}
							});
						}
					});
				}
			} else if (this.type == 'model') {
				this.updateCategory();
			}
			this.$onBus('topbarHandle.fold', this.close);
		},

		beforeDestroy() {
			this.$offBus('topbarHandle.fold');
		},

		methods: {
			handle() {
				if (['option', 'model'].includes(this.type)) {
					this.activeState = true;
					this.$emitBus('topbarHandle.expand', true);
				} else if (this.type == 'sort') {
					this.sortType = this.sortType == 'asc' ? 'desc' : this.sortType == 'desc' ? '' : 'asc';
				}
			},

			optionHandle(item) {
				this.currentOption = this.currentOption == item.value ? '' : item.value;
				this.close();
			},

			modelHandle(item) {
				this.currentModel = this.currentModel && this.currentModel.value == item.value ? null : item;
				this.close();
			},

			close() {
				this.activeState = false;
				this.$emitBus('topbarHandle.expand', false);
			},

			updateCategory() {
				this.request({
					url: '/spu/category/options',
					success: data => {
						this.categoryList = data;
						this.currentCategory = data[0].value;
					}
				});
			},

			updateBrand() {
				this.brandList = [];
				this.modelList = [];
				this.request({
					url: '/spu/brand/options',
					data: {
						category_id: this.currentCategory
					},
					success: data => {
						this.brandList = data;
						if (data.length) {
							if (this.currentBrand == data[0].value) {
								this.updateModel();
							} else {
								this.currentBrand = data[0].value;
							}
						} else {
							this.currentBrand = '';
						}
					}
				});
			},

			updateModel() {
				this.modelList = [];
				this.request({
					url: '/spu/model/options',
					data: {
						category_id: this.currentCategory,
						brand_id: this.currentBrand
					},
					success: data => {
						this.modelList = data;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.u-handle {
		height: 100%;

		&-main {
			gap: .14rem;
			z-index: 1;
			position: relative;
			height: 100%;
			font-size: .3rem;
			background: #fff;
		}

		&-arrow {
			font-size: .22rem;
		}

		&-sort {
			line-height: 1;
			font-size: .18rem;
			color: #bbb;

			.z-active {
				color: var(--color-main);
			}
		}

		&-option {
			position: absolute;
			left: 0;
			right: 0;
			top: 100%;
			max-height: 50vh;
			border-radius: 0 0 .12rem .12rem;
			background: #fff;
			pointer-events: initial;

			ul {
				padding: .15rem 0;

				li {
					height: .8rem;
					padding: 0 .42rem;
					font-size: .3rem;

					&.z-crt {
						color: var(--color-main);
					}
				}
			}
		}

		&-model {
			position: absolute;
			left: 0;
			right: 0;
			top: 100%;
			height: 60vh;
			border-radius: 0 0 .12rem .12rem;
			overflow: hidden;
			background: #fff;
			pointer-events: initial;

			.category {
				ul {
					gap: .14rem;
					box-sizing: border-box;
					min-width: 100%;
					height: .8rem;
					border-bottom: .01rem solid #eee;
					padding: 0 .28rem;

					li {
						border-radius: .08rem;
						padding: 0 .26rem;
						line-height: .56rem;
						font-size: .26rem;
						white-space: nowrap;
						color: #444;
						background: #F5F5F5;

						&.z-crt {
							font-weight: 600;
							color: #fff;
							background: var(--color-main);
						}
					}
				}
			}

			.brand {
				background: #F5F5F5;

				ul {
					width: 1.8rem;
					padding: .16rem 0;

					li {
						line-height: .8rem;
						font-size: .28rem;
						text-align: center;
						color: #444;

						&.z-crt {
							font-size: .3rem;
							font-weight: 600;
							color: var(--color-main);
							background: #fff;
						}
					}
				}
			}

			.model {
				ul {
					gap: .14rem;
					padding: .14rem .22rem;

					li {
						width: 2.56rem;
						height: .8rem;
						border-radius: .08rem;
						line-height: .32rem;
						font-size: .26rem;
						background: #F9F9F9;

						&.z-crt {
							font-weight: 600;
							color: var(--color-main);
						}
					}
				}
			}
		}
	}
</style>
